export const GROUPING_RULES_TITLE_ID = 'grouping-settings-title';
export const GROUPING_RULES_DESCRIPTION_ID = 'grouping-settings-description';
